import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import Missing from '../views/404.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: 'Elin',
    meta: {
        title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/all-home-version/MainDemo.vue')
  },
  {
    path: '/history',
    name: 'History',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/History.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/Terms.vue')
  },
  {
    path: '/privacy_policy',
    name: 'Privacy Policy',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/home',
    name: 'Elin',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/all-home-version/MainDemo.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      title: 'ELIN up επιβράβευση'
    },  
    component: () => import('@/views/Profile.vue')
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    meta: {
      title: 'ELIN up επιβράβευση'
    },  
    component: () => import('@/views/ChangePassword.vue')
  },
  {
    path: '/questions-answers',
    name: 'QuestionsAndAnswers',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/questionsAndAnswers/ServiceDetails.vue')

  },
  {
    path: '/login',
    name: 'Login',  
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/all-home-version/MainDemo.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/button',
    name: 'Button',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/Button.vue')
  },
  {
    path: '/news',
    name: 'News',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/News.vue')
  },
  {
    path: '/test',
    name: 'News',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/Test copy.vue')
  },
  {
    path: '/categories',
    name: 'Categories',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () =>  import(
      "@/views/Categories.vue"
    )
  },
  {
      path: '/my-gifts',
      name: 'Gifts',
      meta: {
        title: 'ELIN up επιβράβευση'
      },
      component: () => import('@/views/Gifts.vue')
    },
    {
      path: '/elin-catalog',
      name: 'Catalog',
      meta: {
        title: 'ELIN up επιβράβευση'
      },
      component: () => import('@/views/CatalogPdf.vue')
    },
    {
      path: '/my-cards',
      name: 'LoyaltyCards',
      meta: {
        title: 'ELIN up επιβράβευση'
      },
      component: () => import('@/views/LoyaltyCards.vue')
      },
    {
      path: '/our-news',
      name: 'OurNews',
      meta: {
        title: 'ELIN up επιβράβευση'
      },
    component: () => import('@/views/OurNews.vue')
    },
    {
      path: '/my-account',
      name: 'MyAccount',
      meta: {
        title: 'ELIN up επιβράβευση'
      },
    component: () => import('@/views/MyAccount.vue')
    },
    {
      path: '/promo-codes',
      name: 'PromoCodes',
      meta: {
        title: 'ELIN up επιβράβευση'
      },
      component: () => import('@/views/PromoCodes.vue')
  },
  
  {
    path: '/contact-form',
    name: 'ContactForm',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/ContactForm.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: {
      title: 'ELIN up επιβράβευση'
    },
    component: () => import('@/views/Contact.vue')
  },
  {
    path: '*',
    component: Missing,
    meta: {
      title: 'ELIN up επιβράβευση'
    },
}
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
 })


export default router
